// extracted by mini-css-extract-plugin
module.exports = {"displayInterface":"displayInterface--1r54v","TDA_OUT_BOX":"TDA_OUT_BOX--2m59X"};